/**
 * Created by xadrian on 17/05/18.
 */
import number_format from './NumberFormat';

export default (value)=>{
    return number_format(value,0,',','.');
}